export enum NgTraditional {
	Book = 'NG::Traditional::Book',
	Chapter = 'NG::Traditional::Chapter',
	PageGroup = 'NG::Traditional::PageGroup',
	Page = 'NG::Traditional::Page'
}
